<template>
  <CModal
    class="staking-confirmation-modal reject-order-modal"
    :show="isShownDeclinedModal"
    :centered="true"
  >
    <template #header>
      <CButtonClose class="close-modal" @click="closeModal" />
    </template>
    <div>
      <div class="tit-dele">
        <h4
          v-if="stepOnDeclinedModal === 1"
        >{{$t('MODAL_DECLINED_COMPONENT_TITLE_REASON_FOR_INFFICIENT_STATUS')}}</h4>
        <h4
          v-if="stepOnDeclinedModal === 2"
        >{{$t('MODAL_DECLINED_COMPONENT_TITLE_CONFIRM_FOR_INFFICIENT_STATUS')}}</h4>
      </div>

      <div class="text-modal">
        <ValidationObserver
          v-if="stepOnDeclinedModal === 1"
          ref="declinedForm"
          v-slot="{ handleSubmit }"
        >
          <CForm @submit.prevent="handleSubmit(declinedKycStatus)">
            <ValidationProvider
              name="MODAL_DECLINED_COMPONENT_FIELD_NAME_VALIDATE_OPTION"
              rules="required"
            >
              <CRow class="form-group" slot-scope="{ errors}">
                <CCol lg="12" md="12">
                  <div
                    role="group"
                    class="form-check"
                    v-for="(option, index) in declinedOptions"
                    :key="index"
                  >
                    <input
                      :id="`declined-${index}`"
                      type="radio"
                      name="reasonOption"
                      class="form-check-input"
                      :value="option.templateName"
                      v-model="reasonOption"
                    />
                    <label :for="`declined-${index}`" class="form-check-label">{{option.subject}}</label>
                    <div>
                      <div class="text-truncate form-text text-muted" v-html="option.description"></div>
                    </div>
                  </div>

                  <span class="error-msg-wrap">
                    <span class="error-msg">{{errors[0]}}</span>
                  </span>
                </CCol>
              </CRow>
            </ValidationProvider>
            <ValidationProvider
              name="MODAL_DECLINED_COMPONENT_FIELD_NAME_VALIDATE_REASON"
              :rules="`${reasonOption == OTHER_OPTION ? 'required': '' }|max:1000`"
            >
              <CRow class="form-group" slot-scope="{ errors}">
                <CCol lg="12" md="12">
                  <textarea
                    type="text"
                    class="form-control"
                    :disabled="reasonOption != OTHER_OPTION"
                    v-model="comments"
                    rows="5"
                  />
                  <span class="error-msg-wrap">
                    <span class="error-msg">{{errors[0]}}</span>
                  </span>
                </CCol>
              </CRow>
            </ValidationProvider>
          </CForm>
        </ValidationObserver>

        <div v-if="stepOnDeclinedModal === 2">
          <div class="reason-option">{{reasonDetails.subject}}</div>
          <div class="reason-description" v-html="reasonDetails.description2"></div>
        </div>
      </div>
    </div>
    <template #footer>
      <CButton
        v-if="stepOnDeclinedModal === 1"
        class="btn-cancel"
        @click="closeModal"
        color="dark"
        variant="outline"
      >{{$t("MODAL_DECLINED_COMPONENT_BUTTON_CANCEL")}}</CButton>

      <CButton
        v-if="stepOnDeclinedModal === 1"
        @click="showConfirmDeclinedForm"
        :disabled="!reasonOption"
        class="btn-ok"
      >{{$t('MODAL_DECLINED_COMPONENT_BUTTON_DECLINED')}}</CButton>

      <CButton
        v-if="stepOnDeclinedModal === 2"
        class="btn-cancel"
        @click="backOnStep"
        color="dark"
        variant="outline"
      >{{$t('MODAL_DECLINED_COMPONENT_BUTTON_BACK')}}</CButton>

      <CButton
        v-if="stepOnDeclinedModal === 2"
        @click="declinedKycStatus"
        class="btn-ok"
      >{{$t('MODAL_DECLINED_COMPONENT_BUTTON_CONFIRM_DECLINED')}}</CButton>
    </template>
  </CModal>
</template>

<script>
const OTHER_OPTION = '___OTHER___';
import responseHelper from '@/utils/response-helper';
import endpoints from '@/constants/endpoints';
import _ from 'lodash';
import stringHelper from '@/utils/string-helper';
import { MembershipOrderStatus } from '@/enums';
import moment from 'moment';
import { Constants, env } from '@/constants';

export default {
  name: 'ModalDeclined',
  props: {
    isShownDeclinedModal: {
      type: Boolean,
      default: false,
    },
    member: {
      type: Object,
      default: () => {},
    },
  },
  components: {},
  data() {
    return {
      OTHER_OPTION: OTHER_OPTION,
      isProcessing: false,
      reasonOption: null,
      declinedOptions: [],
      comments: null,
      stepOnDeclinedModal: 1,
    };
  },
  computed: {
    reasonDetails() {
      const option = this.declinedOptions.find(x => x.templateName === this.reasonOption);
      const result = option || {};

      if (this.reasonOption === OTHER_OPTION) {
        result.description2 = stringHelper.createMarkupWithNewLine(this.comments);
      } else {
        result.description2 = result.description;
      }

      return result;
    },
  },
  async mounted() {
    const memberId = this.$route.params.memberId;
    this.getRejectOptions();
  },
  methods: {
    async getRejectOptions() {
      try {
        const res = await this.$http.get(endpoints.getRejectOptions('CHILDPOOL_KYC_DECLINED'));
        const items = _.sortBy(res.data, 'display_order');
        const declinedOptions = items
          .filter(item => item.language === 'en')
          .map(item => {
            return {
              templateName: item.name,
              subject: item.option_name,
              description: item.subject,
            };
          });
        declinedOptions.push({
          templateName: OTHER_OPTION,
          subject: this.$t('MODAL_DECLINED_COMPONENT_TEXT_SUBJECT_OTHER'),
          description: null,
        });

        this.declinedOptions = declinedOptions;
      } catch (err) {
        this.$notify({
          group: 'notifications',
          type: 'error',
          title: this.$t('MODAL_DECLINED_COMPONENT_TITLE_NOTIFY_ERROR'),
          text: responseHelper.getErrorMessage(err),
        });
      }
    },
    async declinedKycStatus() {
      if (this.isProcessing) {
        return;
      }

      this.isProcessing = true;
      try {
        const data = {
          status: 'DECLINED',
        };
        if (this.reasonOption === OTHER_OPTION) {
          data.note = this.comments;
        } else {
          data.template = this.reasonOption;
        }

        var res = await this.$http.put(endpoints.updateMemberKyc(this.member.id, this.member.kyc_id), data);
        this.$notify({
          group: 'notifications',
          type: 'success',
          title: this.$t('MODAL_DECLINED_COMPONENT_TITLE_NOTIFY_SUCCESS'),
          text: this.$t('MODAL_DECLINED_COMPONENT_TEXT_NOTIFY_SUCCESS'),
        });
        this.$emit('setMemberKycStatus', res.data);
        this.isProcessing = false;
        this.closeModal();
      } catch (err) {
        this.isProcessing = false;
        this.$notify({
          group: 'notifications',
          type: 'error',
          title: this.$t('MODAL_DECLINED_COMPONENT_TITLE_NOTIFY_ERROR'),
          text: responseHelper.getErrorMessage(err),
        });
      }
    },
    async showConfirmDeclinedForm() {
      const isValid = await this.$refs.declinedForm.validate();
      if (!isValid) {
        return;
      }
      this.nextStepOnDeclinedModal();
    },
    closeModal() {
      this.$emit('closeDeclinedModal');
    },
    nextStepOnDeclinedModal() {
      this.stepOnDeclinedModal = 2;
    },
    backOnStep() {
      this.stepOnDeclinedModal = 1;
    },
  },
};
</script>
